module.exports = __webpack_public_path__ + "img/12-2024.8f851fc5.png";